import { render, staticRenderFns } from "./ForumAnswers.vue?vue&type=template&id=15b04cd6&"
import script from "./ForumAnswers.vue?vue&type=script&lang=js&"
export * from "./ForumAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports